import { useMemo } from 'react';
export function useInputHandlers(props) {
  var onFocus = props.onFocus,
    onBlur = props.onBlur,
    onKeyDown = props.onKeyDown,
    onKeyUp = props.onKeyUp,
    onKeyPress = props.onKeyPress;
  var handlers = useMemo(function () {
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, onBlur && {
      onBlur: onBlur
    }), onFocus && {
      onFocus: onFocus
    }), onKeyDown && {
      onKeyDown: onKeyDown
    }), onKeyUp && {
      onKeyUp: onKeyUp
    }), onKeyPress && {
      onKeyPress: onKeyPress
    });
  }, [onFocus, onBlur, onKeyDown, onKeyUp, onKeyPress]);
  return handlers;
}
export function useTextareaHandlers(props) {
  var onFocus = props.onFocus,
    onBlur = props.onBlur,
    onKeyDown = props.onKeyDown,
    onKeyUp = props.onKeyUp,
    onKeyPress = props.onKeyPress;
  var handlers = useMemo(function () {
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, onBlur && {
      onBlur: onBlur
    }), onFocus && {
      onFocus: onFocus
    }), onKeyDown && {
      onKeyDown: onKeyDown
    }), onKeyUp && {
      onKeyUp: onKeyUp
    }), onKeyPress && {
      onKeyPress: onKeyPress
    });
  }, [onFocus, onBlur, onKeyDown, onKeyUp, onKeyPress]);
  return handlers;
}